import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import CustomButton from "../../reusable_components/custom_button_component/Button";
import { saveTemplateFile } from "../CreateOrEditEditorComponent/CreateOrEditEditorComponent.service";
import alertModalStyles from "../../../Reusables/components/AlertModal/AlertModal.module.css";

import CheckboxInput from "../../../Reusables/components/CheckboxInput/CheckboxInput";

interface TemplateSettingsModalProps {
  templateId: number | null;
  title?: string;
  show: boolean;
  templateData: any;
  onHide: (didSave: boolean) => void;
}

const TemplateSettingModal: React.FC<TemplateSettingsModalProps> = ({
  templateId,
  show,
  templateData,
  onHide,
}) => {
  const [didSave, setDidSave] = useState(false);
  const [apiProgress, setApiProgress] = useState(false);
  const [originalBulk, setOriginalBulk] = useState(templateData?.BulkUpload === "Y");
  const [originalAuto, setOriginalAuto] = useState(templateData?.AutoApproval === "Y");

  const [bulkUploadCheck, setBulkUploadCheck] = useState<boolean>(
    templateData?.BulkUpload === "Y"
  );
  const [autoApprovalCheck, setAutoApprovalCheck] = useState<boolean>(
    templateData?.AutoApproval === "Y"
  );

  useEffect(() => {
    setBulkUploadCheck(templateData?.BulkUpload === "Y");
    setAutoApprovalCheck(templateData?.AutoApproval === "Y");

    setOriginalBulk(templateData?.BulkUpload === "Y");
    setOriginalAuto(templateData?.AutoApproval === "Y");
  }, [templateData, show]);

  const hasChanges =
    bulkUploadCheck !== originalBulk ||
    autoApprovalCheck !== originalAuto;

  const handleSave = async () => {
    if (!templateId) return;

    setApiProgress(true);
    try {
      await saveTemplateFile(
        templateId,
        undefined,
        undefined,
        undefined,
        undefined,
        autoApprovalCheck ? "Y" : "N",
        bulkUploadCheck ? "Y" : "N"
      );

      setOriginalBulk(bulkUploadCheck);
      setOriginalAuto(autoApprovalCheck);
      setDidSave(true);
    } catch (e) {}
    setApiProgress(false);
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        onHide(didSave);
        setDidSave(false);
      }}
      dialogClassName={alertModalStyles.dialog}
      contentClassName={`${alertModalStyles.content}`}
      backdropClassName={alertModalStyles.backdrop}
      centered
      keyboard={false}
    >
      <Modal.Header closeButton className={alertModalStyles.header}>
        <Modal.Title className={alertModalStyles.message}>
          Template Settings
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div style={{ display: "flex", gap: "10px" }}>
          <CheckboxInput
            field={{
              id: "autoApproval",
              type: "checkbox",
              label: "Auto Approval",
              value: autoApprovalCheck,
              show: true,
              labelPosition: "right",
              textStyle: { fontSize: 13 },
            }}
            handleChange={(fieldId, e) => {
              setAutoApprovalCheck(e.target.checked);
            }}
            handleBlur={() => {}}
            handleSelect={() => {}}
          />
          <CheckboxInput
            field={{
              id: "bulkUpload",
              type: "checkbox",
              label: "Bulk Upload",
              value: bulkUploadCheck,
              show: true,
              labelPosition: "right",
              textStyle: { fontSize: 13 },
            }}
            handleChange={(fieldId, e) => {
              setBulkUploadCheck(e.target.checked);
            }}
            handleBlur={() => {}}
            handleSelect={() => {}}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className={alertModalStyles.footer}>
        <CustomButton 
          content={"Cancel"} 
          type={"quinary"} 
          onclick={() => {
            onHide(didSave);
            setDidSave(false);
          }} 
        />
        <CustomButton
          content={"Save"}
          type={"tertiary"}
          onclick={handleSave}
          progress={apiProgress}
          disabled={!hasChanges || apiProgress}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default TemplateSettingModal;
